module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/demos/home-portfolio-c81b943982b25998ebe2297bf9f9731c.png";